// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDs8vFlhu2dQx6mXzTwcOclikwtwu_DBDc",
  authDomain: "share-calendar-6dd47.firebaseapp.com",
  databaseURL: "https://share-calendar-6dd47-default-rtdb.firebaseio.com",
  projectId: "share-calendar-6dd47",
  storageBucket: "share-calendar-6dd47.appspot.com",
  messagingSenderId: "17493701904",
  appId: "1:17493701904:web:8cf5b1abf93516eb0fe195",
  measurementId: "G-P5NYY3ML0R",
};

// firebaseConfig 정보로 firebase 시작
firebase.initializeApp(firebaseConfig);

// firebase의 firestore 인스턴스를 변수에 저장
const firestore = firebase.firestore();

// 필요한 곳에서 사용할 수 있도록 내보내기
// 다른 곳에서 불러올때 firestore로 불러와야 함!!
export { firestore };
